interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-16 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-200 text-foreground-400">
        <i className={`${icon} text-2xl`} />
      </span>
      <p className="mt-4 font-heading text-base font-semibold text-foreground-800">{title}</p>
      {description && (
        <p className="mt-2 max-w-md text-sm leading-6 text-foreground-500">{description}</p>
      )}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 inline-flex items-center gap-1.5 rounded-md bg-primary-700 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-800 cursor-pointer"
        >
          <i className="ri-refresh-line" />
          {actionLabel}
        </button>
      )}
    </div>
  );
}